import React, { useState, useRef, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import FormControl from '@material-ui/core/FormControl';
// import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import Button from '@material-ui/core/Button';
import Select from '@material-ui/core/Select';
import './styles.css';
import { MenuItem } from '@material-ui/core';
import DialogActions from '@material-ui/core/DialogActions';
import axios from 'axios';
import SuccessPopUp from '../../loaderpopup/success';
import ErrorPopUp from '../../loaderpopup/error';
import Card from '@mui/material/Card';
import Avatar from '@mui/material/Avatar';
import PdfRender from '../pdfRender';
import { CommonConfig } from '../../../config/common-config';
import CardContent from '@mui/material/CardContent';
import Badge from '@mui/material/Badge';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`scrollable-auto-tabpanel-${index}`}
            aria-labelledby={`scrollable-auto-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `scrollable-auto-tab-${index}`,
        'aria-controls': `scrollable-auto-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
    // root: {
    //     flexGrow: 1,
    //     width: '100%',
    //     backgroundColor: theme.palette.background.paper,
    // },
    margin: {
        margin: theme.spacing(1),
    },
    withoutLabel: {
        marginTop: theme.spacing(3),
    },
    textField: {
        width: '25ch',
    },
    bottomLine: {
        '&:before': {
            borderBottom: '1px solid #ccc !important',
        },
    },
    checked: {},
    icon: {
        borderRadius: '50%',
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: '#137cbd',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#106ba3',
        },
    },
    inlineDisplay: {
        listStyle: 'none',
        padding: '0',
        '& li': {
            display: 'inline-block',
            padding: '0px 10px 0px 0px',
            color: '#7779ba',
        },
        '& label': {
            marginLeft: '0',
        },
    },
    expenditure: {
        listStyle: 'none',
        padding: '0',
        '& li': {
            padding: '10px 0',
            color: '#7779ba',
        },
        '& label': {
            marginLeft: '0',
        },
    },
    adornedEnd: {
        width: '20px',
        marginLeft: '300px',
        fontSize: '8px',
        height: '17px',
    },
    button: {
        fontSize: '15px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '6px 25px',
        letterSpacing: 'normal',
    },
    mt15: {
        marginTop: '15px !important',
    },
    selectView: {
        '&:before': {
            borderBottom: '1px solid #ccc !important',
        },
        fontSize: '14px',
        paddingTop: '15px',
        '& .MuiSelect-icon': {
            // display: 'none',
            // right: '50%',
        },
    },
    uploadBtn: {
        width: '30px',
        fontSize: '10px !important',
        height: '20px',
        textTransform: 'capitalize',
        fontWeight: '400 !important',
    },
    btnGrey: {
        color: '#ccc !important',
        border: '1px solid #ccc !important',
        cursor: 'default',
    },
}));
function StyledRadio(props) {
    const classes = useStyles();

    return (
        <Radio
            className={classes.root}
            disableRipple
            color="default"
            checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
            icon={<span className={classes.icon} />}
            {...props}
        />
    );
}

export default function Partnership(props) {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);
    const [IsUploading, setIsUploading] = useState(0);
    const [successpop, setSuccessPop] = React.useState(false);
    const [errorpop, setErrorPop] = React.useState(false);
    const [selectedFileData, setSelectedFileData] = React.useState(null);
    const [title, setTitle] = React.useState('');
    const [isDisable, setIsDisable] = React.useState(true);
    const [error, setError] = useState(1);
    const [filenameIncorporation, setFilenameIncorporation] = React.useState('');
    const [filenameReview, setFilenameReview] = React.useState('');
    const [filenameOfficeProof, setFilenameOfficeProof] = React.useState('');
    const fileInputIncorporationRef = useRef(null);
    const fileInputOfficeProofRef = useRef(null);
    const fileInputReviewRef = useRef(null);
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleModalClose = () => setOpen(false);

    const [values, setValues] = React.useState({
        incorporation_certificate: '',
        incorporation_document: '',
        admin_office_address_proof: '',
        company_incorporation_details: [],
        status: '',
        address: '',
    });

    useEffect(() => {
        setValues(props.IncorporationData);
    }, [props.IncorporationData]);

    const fileUpload = (e, fieldName) => {
        e.preventDefault();

        if (fieldName == 'company_incorporation_certificate') {
            setFilenameIncorporation(e.target.files[0].name);
        } else if (fieldName == 'company_review_document') {
            setFilenameReview(e.target.files[0].name);
        } else {
            setFilenameOfficeProof(e.target.files[0].name);
        }

        const data = new FormData();
        data.append('file', e.target.files[0]);
        setIsUploading(1);
        axios
            .post(
                `${CommonConfig.dev.appUrl}/api/admin/admin_incorporation/${values.company_incorporation_details?.[0]?.id}/fileupload`,
                data,
                {
                    // headers: {
                    //     Authorization:
                    //         'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjp7ImlkIjo0OSwiZW1haWwiOiJhcnVuQG1pbmRzdGFjay5pbiIsImZpcnN0X25hbWUiOiJzaGF6YWQiLCJsYXN0X25hbWUiOiJtYXZlZCJ9LCJpYXQiOjE2ODU5NDMyNjQsImV4cCI6MTY4NjAyOTY2NH0.t9gUU5Kh-qtFofgfzfpZMF1o57DqRGdUzUYWROctLtY',
                    // },
                }
            )
            .then((response) => {
                setTitle('File uploaded successfuly');
                setSuccessPop(true);
                setIsUploading(0);
                if (response.data) {
                    if (fieldName == 'company_incorporation_document') {
                        setValues({ ...values, incorporation_certificate: response.data.data.path });
                    } else if (fieldName == 'company_review_document') {
                        setValues({ ...values, incorporation_document: response.data.data.path });
                    } else if (fieldName == 'company_incorporation_certificate') {
                        setValues({ ...values, incorporation_certificate: response.data.data.path });
                    } else {
                        setValues({ ...values, admin_office_address_proof: response.data.data.path });
                    }
                }
                console.log(values);
            })
            .catch((error) => {
                setIsUploading(0);
                if (error && error.response && error.response.data) {
                    setTitle('File uploaded failed');
                    setErrorPop('File upload failed');
                }
            });
    };

    //console.log('values from child', values);
    const handleClose = () => {
        setSuccessPop(false);
    };

    const handleCloseError = () => {
        setErrorPop(false);
    };

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleChangeSelect = (prop) => (event) => {
        const selectedValue = event.target.value;
        if (prop == 'status' && selectedValue == '') {
            setError(1);
        } else {
            setError(0);
        }
        setValues({
            ...values,
            company_incorporation_details: [
                {
                    ...values.company_incorporation_details[0],
                    [prop]: selectedValue,
                },
            ],
        });
    };

    const handleSubmit = () => {
        values.company_incorporation_details[0]?.status ? setError(0) : setError(1);
        if (error == 0) {
            const url = `${CommonConfig.dev.appUrl}/api/admin/admin_incorporation/${values.company_incorporation_details?.[0]?.id}`;
            const data = {
                status: values.company_incorporation_details[0]?.status,
                incorporation_certificate: values.incorporation_certificate,
                admin_office_address_proof: values.admin_office_address_proof,
                incorporation_document: values.incorporation_document,
                address: values.address,
            };

            console.log(data);
            // const headers = {
            //     Authorization:
            //         'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjp7ImlkIjo0OSwiZW1haWwiOiJhcnVuQG1pbmRzdGFjay5pbiIsImZpcnN0X25hbWUiOiJzaGF6YWQiLCJsYXN0X25hbWUiOiJtYXZlZCJ9LCJpYXQiOjE2ODYxMTg0MzcsImV4cCI6MTY4NjIwNDgzN30.g0XVdqCLZ-Q6oNMOZ9TF4xQX4O_20XWfuQ672Tcn8AY',
            //     'Content-Type': 'application/json',
            // };

            if (IsUploading == 1) {
                setTitle('File Upload is in Progress');
                setErrorPop(true);
            } else {
                axios
                    .patch(url, data)
                    .then((response) => {
                        setTitle('Data Updated Successfuly');
                        setSuccessPop(true);
                    })
                    .catch(() => {
                        setTitle('Data Updation failed');
                        setErrorPop(true);
                    });
            }
        }
    };

    return (
        <div className="main-container w100">
            <AppBar position="static" color="default" className="custom-tab">
                <Tabs
                    value={value}
                    onChange={handleChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="scrollable"
                    scrollButtons="auto"
                    aria-label="scrollable auto tabs example"
                    style={{ display: 'block' }}
                >
                    <Tab label="Basic Details" {...a11yProps(0)} />
                    <Tab
                        label={
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                <span>Shareholders</span>
                                {values.company_incorporation_details?.[0]?.status == 'shareholder_created' ? (
                                    <Badge badgeContent="1" color="error" style={{ marginRight: '5px' }} />
                                ) : null}
                            </div>
                        }
                        {...a11yProps(1)}
                    />
                    {/* <Tab label="Directors" {...a11yProps(2)} /> */}

                    <Tab
                        label={
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                <span>Office Space</span>
                                {values.company_incorporation_details?.[0]?.status == 'office_space' ||
                                values.company_incorporation_details?.[0]?.status == 'get_office_space' ||
                                values.company_incorporation_details?.[0]?.status == 'have_office_space' ? (
                                    <Badge badgeContent="1" color="error" style={{ marginRight: '5px' }} />
                                ) : null}
                            </div>
                        }
                        {...a11yProps(3)}
                    />
                    <Tab
                        label={
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                <span>Review Document</span>
                                {values.company_incorporation_details?.[0]?.status == 'Incorporation Payment Successful' ? (
                                    <Badge badgeContent="1" color="error" style={{ marginRight: '5px' }} />
                                ) : null}
                            </div>
                        }
                        {...a11yProps(4)}
                    />
                    {/* <Tab label="Other Sources" {...a11yProps(4)} />
                    <Tab label="Agricultural Income" {...a11yProps(5)} /> */}
                    {/* <Tab label="Deductions" {...a11yProps(6)} /> */}
                </Tabs>
            </AppBar>
            <TabPanel value={value} index={0}>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth className={classes.margin}>
                            <InputLabel htmlFor="donation-details">Proposed Name</InputLabel>
                            <Input
                                disabled
                                className={classes.bottomLine}
                                id="donation-details"
                                value={values.company_incorporation_details?.[0]?.proposed_name || ''}
                                // onChange={handleChange('amount')}
                            />
                        </FormControl>
                    </Grid>
                    {/* <Grid item xs={12} sm={6}>
                        <FormControl fullWidth className={classes.margin}>
                            <InputLabel htmlFor="investments">State</InputLabel>
                            <Input
                                disabled
                                className={classes.bottomLine}
                                id="investments"
                                value={values.company_incorporation_details?.[0]?.state || ''}
                                // onChange={handleChange('amount')}
                            />
                        </FormControl>
                    </Grid> */}
                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth>
                            <InputLabel htmlFor="status">Status</InputLabel>

                            <Select
                                className={classes.bottomLine}
                                id="standard-adornment-amount"
                                value={values.company_incorporation_details?.[0]?.status || ''}
                                onChange={handleChangeSelect('status')}
                                name="status"
                                disabled={
                                    props.IncorporationData.company_incorporation_details?.[0]?.status == 'Application Rejected' ||
                                    props.IncorporationData.company_incorporation_details?.[0]?.status == 'Partnership Incorporated'
                                        ? true
                                        : false
                                }
                            >
                                <MenuItem value="Application Resubmission">Application Resubmission</MenuItem>
                                <MenuItem value="Application Rejected">Application Rejected</MenuItem>
                                <MenuItem value="Partnership Incorporated">Partnership Incorporated</MenuItem>
                                <MenuItem value="Partnership Deed Sent">Partnership Deed Sent</MenuItem>
                                {/* <MenuItem value="Office Address Updated">Office Address Updated</MenuItem> */}
                                {/* <MenuItem value="Review Document Updated">Review Document Updated</MenuItem> */}
                            </Select>
                        </FormControl>
                        <p style={{ color: 'red' }}>{error == 1 ? 'Status is required' : ''}</p>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth style={{ display: 'flex', flexDirection: 'column' }}>
                            <InputLabel htmlFor="pin">Partnership Deed</InputLabel>

                            <DialogActions className="paddingBtm txtCenter" style={{ marginLeft: '50px' }}>
                                <Button
                                    className={isDisable ? classes.disableBtn : 'btnBluepop'}
                                    onClick={(e) => {
                                        fileInputIncorporationRef.current.click();
                                    }}
                                    variant="contained"
                                    // disabled={isDisable}
                                    component="label"
                                    // color="default"
                                    disabled={
                                        props.IncorporationData.company_incorporation_details?.[0]?.status == 'Application Rejected' ||
                                        props.IncorporationData.company_incorporation_details?.[0]?.status == 'Partnership Incorporated'
                                            ? true
                                            : false
                                    }
                                >
                                    Upload
                                </Button>
                                <input
                                    type="file"
                                    name="company_incorporation_certificate"
                                    ref={fileInputIncorporationRef}
                                    accept=".pdf"
                                    style={{ display: 'none' }}
                                    onChange={(e) => {
                                        fileUpload(e, 'company_incorporation_certificate');
                                    }}
                                />
                            </DialogActions>
                        </FormControl>
                        {filenameIncorporation ? <p className="fileNameGreen">{filenameIncorporation}</p> : ''}

                        {values.company_incorporation_details?.[0]?.incorporation_certificate ? (
                            <>
                                <p style={{ marginTop: 0 }}>
                                    <a
                                        href={values.company_incorporation_details?.[0]?.incorporation_certificate}
                                        target="_blank"
                                        style={{ textDecoration: 'none', color: '#4c4fa6' }}
                                    >
                                        View
                                    </a>
                                </p>
                            </>
                        ) : (
                            ''
                        )}
                    </Grid>
                </Grid>
            </TabPanel>
            <TabPanel value={value} index={1}>
                <Grid container spacing={3}>
                    {values.company_incorporation_details &&
                        values.company_incorporation_details?.[0]?.company_shareholders?.map((shareholder) => {
                            return (
                                <>
                                    <Grid item xs={12} sm={4}>
                                        <Card>
                                            <CardContent>
                                                <Avatar alt="" src={shareholder.photo} />
                                                {shareholder.equity_shares == 0 ? (
                                                    <small>
                                                        Shareholdings : <strong>{shareholder.equity_stake} %</strong>
                                                    </small>
                                                ) : (
                                                    <small>
                                                        Shareholdings : <strong>{shareholder.equity_shares} shares</strong>
                                                    </small>
                                                )}
                                                <Typography variant="h5">{shareholder.full_name}</Typography>
                                                <small>Is Director? : {shareholder.is_director === 1 ? 'Yes' : 'No'}</small>
                                                <Typography variant="body2">
                                                    Email : {shareholder.email}
                                                    <br />
                                                    Phone : {shareholder.phone}
                                                    <br />
                                                    PAN : {shareholder.pan}
                                                    <br />
                                                    Occupation : {shareholder.occupation}
                                                    <br />
                                                    Education : {shareholder.education_qualification}
                                                    <br />
                                                    Residential Proof Type: {shareholder.residencial_proof_type}
                                                    <br /> Residential Proof :{' '}
                                                    <a
                                                        href={shareholder.residencial_proof}
                                                        target="_blank"
                                                        style={{ textDecoration: 'none', color: '#3f51b5' }}
                                                    >
                                                        View
                                                    </a>
                                                    <br />
                                                    Identity Proof Type: {shareholder.identity_proof_type}
                                                    <br />
                                                    Identity Proof :{' '}
                                                    <a
                                                        href={shareholder.identity_proof}
                                                        target="_blank"
                                                        style={{ textDecoration: 'none', color: '#3f51b5' }}
                                                    >
                                                        View
                                                    </a>
                                                </Typography>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                </>
                            );
                        })}
                </Grid>
            </TabPanel>

            <TabPanel value={value} index={2}>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={12}>
                        <FormControl fullWidth className={classes.margin}>
                            <Typography variant="subtitle1" gutterBottom>
                                Do you have any office space?
                            </Typography>
                            <div>
                                <FormControl component="fieldset">
                                    <RadioGroup
                                        disabled
                                        defaultValue="Yes"
                                        aria-label="yes-no"
                                        name="customized-radios"
                                        className="radio-option"
                                    >
                                        <ul className={classes.inlineDisplay}>
                                            <li>
                                                <FormControlLabel
                                                    value="Yes"
                                                    control={<StyledRadio />}
                                                    label="Yes"
                                                    checked={values.company_incorporation_details?.[0]?.have_office_space === true}
                                                />
                                            </li>
                                            <li>
                                                <FormControlLabel
                                                    value="No"
                                                    control={<StyledRadio />}
                                                    disabled
                                                    label="No"
                                                    className="cursor-default"
                                                    checked={values.company_incorporation_details?.[0]?.have_office_space === false}
                                                />
                                            </li>
                                        </ul>
                                    </RadioGroup>
                                </FormControl>
                            </div>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <FormControl fullWidth className={classes.margin}>
                            <Typography variant="subtitle1" gutterBottom>
                                Do you want us to help you to find the office space in these cities?
                            </Typography>
                            <div>
                                <FormControl component="fieldset">
                                    <RadioGroup
                                        disabled
                                        defaultValue="Yes"
                                        aria-label="yes-no"
                                        name="customized-radios"
                                        className="radio-option"
                                    >
                                        <ul className={classes.inlineDisplay}>
                                            <li>
                                                <FormControlLabel
                                                    value="Yes"
                                                    control={<StyledRadio />}
                                                    label="Yes"
                                                    checked={values.company_incorporation_details?.[0]?.want_office_space === true}
                                                />
                                            </li>
                                            <li>
                                                <FormControlLabel
                                                    value="No"
                                                    control={<StyledRadio />}
                                                    disabled
                                                    label="No"
                                                    className="cursor-default"
                                                    checked={values.company_incorporation_details?.[0]?.want_office_space === false}
                                                />
                                            </li>
                                        </ul>
                                    </RadioGroup>
                                </FormControl>
                            </div>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth className={classes.margin}>
                            <InputLabel htmlFor="investments">City</InputLabel>
                            <Input
                                disabled
                                className={classes.bottomLine}
                                id="investments"
                                value={values.company_incorporation_details?.[0]?.want_office_space_city || ''}
                                // onChange={handleChange('amount')}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth className={classes.margin}>
                            <InputLabel htmlFor="investments">Partners Address</InputLabel>
                            <Input
                                disabled
                                className={classes.bottomLine}
                                id="investments"
                                value={values.company_incorporation_details?.[0]?.address || ''}
                                onChange={handleChangeSelect('address')}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth className={classes.margin}>
                            <InputLabel htmlFor="pin">Office Address</InputLabel>
                            <DialogActions className="paddingBtm txtCenter" style={{ marginLeft: '50px' }}>
                                <Button
                                    className={isDisable ? classes.disableBtn : 'btnBluepop'}
                                    onClick={(e) => {
                                        fileInputOfficeProofRef.current.click();
                                    }}
                                    variant="contained"
                                    // disabled={isDisable}
                                    component="label"
                                    // color="default"
                                    disabled={
                                        props.IncorporationData.company_incorporation_details?.[0]?.status == 'Application Rejected' ||
                                        props.IncorporationData.company_incorporation_details?.[0]?.status == 'Partnership Incorporated'
                                            ? true
                                            : false
                                    }
                                >
                                    Upload
                                </Button>
                                <input
                                    type="file"
                                    name="office_address_proof"
                                    ref={fileInputOfficeProofRef}
                                    style={{ display: 'none' }}
                                    onChange={(e) => {
                                        fileUpload(e, 'office_address_proof');
                                    }}
                                />
                            </DialogActions>
                        </FormControl>
                        {filenameOfficeProof ? <p className="fileNameGreen">{filenameOfficeProof}</p> : ''}

                        {values.company_incorporation_details?.[0]?.office_address_proof ? (
                            <>
                                <p style={{ marginTop: 0 }}>
                                    <a
                                        href={values.company_incorporation_details?.[0]?.office_address_proof}
                                        target="_blank"
                                        style={{ textDecoration: 'none', color: '#4c4fa6' }}
                                    >
                                        View user uploaded office proof
                                    </a>
                                </p>
                            </>
                        ) : (
                            ''
                        )}

                        {values.company_incorporation_details?.[0]?.admin_office_address_proof &&
                        values.company_incorporation_details?.[0]?.admin_office_address_proof !== '0' ? (
                            <>
                                <p style={{ marginTop: 0 }}>
                                    <a
                                        href={values.company_incorporation_details?.[0]?.admin_office_address_proof}
                                        target="_blank"
                                        style={{ textDecoration: 'none', color: '#4c4fa6' }}
                                    >
                                        View admin uploaded office proof
                                    </a>
                                </p>
                            </>
                        ) : (
                            ''
                        )}
                    </Grid>
                </Grid>

                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth required>
                        <InputLabel htmlFor="status">Status</InputLabel>

                        <Select
                            className={classes.bottomLine}
                            id="standard-adornment-amount"
                            value={values.company_incorporation_details?.[0]?.status || ''}
                            onChange={handleChangeSelect('status')}
                            name="status"
                            disabled={
                                props.IncorporationData.company_incorporation_details?.[0]?.status == 'Application Rejected' ||
                                props.IncorporationData.company_incorporation_details?.[0]?.status == 'Company Incorporated'
                                    ? true
                                    : false
                            }
                        >
                            <MenuItem value="">Select Status</MenuItem>
                            <MenuItem value="Office Address Updated">Office Address Updated</MenuItem>
                        </Select>
                    </FormControl>
                    <p style={{ color: 'red' }}>{error == 1 ? 'Status is required' : ''}</p>
                </Grid>
            </TabPanel>
            <TabPanel value={value} index={3}>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth style={{ display: 'flex', flexDirection: 'column' }}>
                            <InputLabel htmlFor="pin">Review Document</InputLabel>

                            <DialogActions className="paddingBtm txtCenter" style={{ marginLeft: '50px' }}>
                                <Button
                                    className={isDisable ? classes.disableBtn : 'btnBluepop'}
                                    onClick={(e) => {
                                        fileInputReviewRef.current.click();
                                    }}
                                    variant="contained"
                                    // disabled={isDisable}
                                    component="label"
                                    // color="default"
                                    disabled={
                                        props.IncorporationData.company_incorporation_details?.[0]?.status == 'Application Rejected' ||
                                        props.IncorporationData.company_incorporation_details?.[0]?.status == 'Company Incorporated'
                                            ? true
                                            : false
                                    }
                                >
                                    Upload
                                </Button>
                                <input
                                    type="file"
                                    name="company_review_document"
                                    accept=".pdf"
                                    ref={fileInputReviewRef}
                                    style={{ display: 'none' }}
                                    onChange={(e) => {
                                        fileUpload(e, 'company_review_document');
                                    }}
                                />
                            </DialogActions>
                        </FormControl>

                        {filenameReview ? <p className="fileNameGreen">{filenameReview}</p> : ''}

                        {values.company_incorporation_details?.[0]?.incorporation_document ? (
                            <>
                                <p style={{ marginTop: 0 }}>
                                    <a
                                        href={values.company_incorporation_details?.[0]?.incorporation_document}
                                        target="_blank"
                                        style={{ textDecoration: 'none', color: '#4c4fa6' }}
                                    >
                                        View
                                    </a>
                                </p>
                            </>
                        ) : (
                            ''
                        )}

                        {values.company_incorporation_details?.[0]?.incorporation_document_commented ? (
                            <>
                                <p style={{ marginTop: 0 }}>
                                    <a href="javascript:void(0);" onClick={handleOpen} style={{ textDecoration: 'none', color: '#4c4fa6' }}>
                                        View Commented Document
                                    </a>
                                </p>
                            </>
                        ) : (
                            ''
                        )}

                        {values.company_incorporation_details?.[0]?.incorporation_document_signed ? (
                            <p style={{ marginTop: 0 }}>
                                <a
                                    href={values.company_incorporation_details?.[0]?.incorporation_document_signed}
                                    target="_blank"
                                    style={{ textDecoration: 'none', color: '#4c4fa6' }}
                                >
                                    View Signed Incorporation Document
                                </a>
                            </p>
                        ) : (
                            ''
                        )}
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth required>
                            <InputLabel htmlFor="status">Status</InputLabel>

                            <Select
                                className={classes.bottomLine}
                                id="standard-adornment-amount"
                                value={values.company_incorporation_details?.[0]?.status || ''}
                                onChange={handleChangeSelect('status')}
                                name="status"
                                disabled={
                                    props.IncorporationData.company_incorporation_details?.[0]?.status == 'Application Rejected' ||
                                    props.IncorporationData.company_incorporation_details?.[0]?.status == 'Company Incorporated'
                                        ? true
                                        : false
                                }
                            >
                                <MenuItem value="Review Document Updated">Review Document Updated</MenuItem>
                            </Select>
                        </FormControl>
                        <p style={{ color: 'red' }}>{error == 1 ? 'Status is required' : ''}</p>
                    </Grid>
                </Grid>
            </TabPanel>
            <div style={{ textAlign: 'center', marginTop: '25px' }}>
                <Button
                    className="btnBluepop"
                    onClick={handleSubmit}
                    variant="contained"
                    // disabled={isDisable}
                    component="label"
                    // color="default"
                >
                    Submit
                </Button>
            </div>

            {successpop ? (
                <SuccessPopUp
                    open={successpop}
                    showSuccess={successpop}
                    handleClose={handleClose}
                    title={title}
                    disableBackdropClick={false}
                />
            ) : null}
            {errorpop ? (
                <ErrorPopUp
                    open={errorpop}
                    showError={errorpop}
                    handleClose={handleCloseError}
                    title={title}
                    disableBackdropClick={false}
                />
            ) : null}
            <PdfRender handleClose={handleModalClose} open={open} data={values.company_incorporation_details?.[0]}></PdfRender>
        </div>
    );
}
